// external dependencies
import React from 'react'
import styled from '@emotion/styled'

// constants
import { COLORS, FONT_SIZES, MQ } from 'utils/styleHelpers'
const HEADLINE_SM = '2.0rem'
const HEADLINE_LG = '2.5rem'
const WIDTH_LG = '50%'
const WIDTH_SM = '60%'

// styled components
const H1 = styled.h1`
	color: ${COLORS.WHITE};
	font-size: ${FONT_SIZES.H3};
	font-weight: 500;
	line-height: ${FONT_SIZES.H3};
	margin: 0;
	padding: 2px 0;

	${MQ.XS} {
		font-size: ${HEADLINE_SM};
		line-height: ${HEADLINE_SM};
	}

	${MQ.M} {
		font-size: ${HEADLINE_LG};
		line-height: ${HEADLINE_LG};
	}
`

const H2 = styled.h2`
	color: ${COLORS.BLUE_LIGHT};
	font-weight: bold;
	font-size: ${FONT_SIZES.H3};
	line-height: ${FONT_SIZES.H3};
	margin: 0;
	padding: 2px 0;

	${MQ.XS} {
		font-size: ${HEADLINE_SM};
		line-height: ${HEADLINE_SM};
	}

	${MQ.M} {
		font-size: ${HEADLINE_LG};
		line-height: ${HEADLINE_LG};
	}
`

const Paragraph = styled.p`
	color: ${COLORS.WHITE};
	font-size: ${FONT_SIZES.H4};
	padding: 20px 0;
	margin-bottom: 0;

	${MQ.S} {
		line-height: 20px;
		width: ${WIDTH_SM};
	}

	${MQ.L} {
		width: ${WIDTH_LG};
	}
`

const UnorderedList = styled.ul`
	list-style-type: none;
	margin: initial;
	padding: 0 0 0 20px;
	width: 80%;

	${MQ.S} {
		font-size: ${FONT_SIZES.H4};
		width: ${WIDTH_SM};
	}

	${MQ.L} {
		width: ${WIDTH_LG};
	}
`

const ListItem = styled.li`
	color: ${COLORS.WHITE};
	display: list-item;
	padding: 5px 12px 5px 12px;
	text-indent: -20px;

	${MQ.XS} {
		line-height: 20px;
	}

	&::before {
		background-color: ${COLORS.BLUE_LIGHT};
		border-radius: 50%;
		content: '';
		display: inline-block;
		margin-right: 12px;
		margin-bottom: 2px;
		height: 8px;
		width: 8px;
	}
`

const Strong = styled.strong`
	font-weight: bold;
`

const Image = styled.img`
	position: absolute;
	top: 0;
	left: 40px;
`

export default {
	h1: props => <H1 {...props} />,
	h2: props => <H2 {...props} />,
	p: props => <Paragraph {...props} />,
	img: props => <Image {...props} />,
	ul: props => <UnorderedList {...props} />,
	li: props => <ListItem {...props} />,
	strong: props => <Strong {...props} />,
}
